export default __webpack_public_path__ + "static/media/about-greeting-text.f968da10.svg";